module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_ManchesterCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_ManchesterCity.png
// module id = 2191
// module chunks = 4